import { useState, useEffect } from 'react';
import './hero.css';
import { handleAnchorClick } from '../utils/smoothScroll';

function AnimatedWord({ text, baseDelay }) {
  return (
    <span className="anim-word" aria-label={text}>
      {text.split('').map((char, i) => (
        <span
          key={i}
          className="anim-letter"
          style={{ animationDelay: `${baseDelay + i * 0.045}s` }}
        >
          {char}
        </span>
      ))}
    </span>
  );
}

function Typewriter({ text, startDelay }) {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    let timeout;
    timeout = setTimeout(() => {
      let i = 0;
      const tick = setInterval(() => {
        i++;
        setDisplayed(text.slice(0, i));
        if (i >= text.length) clearInterval(tick);
      }, 52);
      return () => clearInterval(tick);
    }, startDelay * 1000);
    return () => clearTimeout(timeout);
  }, [text, startDelay]);

  return (
    <span>
      {displayed}
      <span className="type-cursor" aria-hidden="true">|</span>
    </span>
  );
}

function Hero() {
  return (
    <section className="hero">
      <div className="hero-bg-grid" />
      <div className="hero-glow" />

      <div className="hero-content">
        <p className="hero-label font-mono">Portfolio — 2026</p>

        <h1 className="hero-name">
          <AnimatedWord text="BEAUX" baseDelay={0.25} />
          <AnimatedWord text="DOLF" baseDelay={0.55} />
        </h1>

        <div className="hero-divider" />

        <p className="hero-role font-mono">
          <Typewriter text="CS Student · Security · Backend" startDelay={1.4} />
        </p>

        <p className="hero-description">
          Motivated 3rd year Computer Science student seeking opportunities in Software Engineering and IT Cybersecurity.
          Strong technical background with a focus on networking, security tooling, and full-stack development.
        </p>

        <div className="hero-buttons">
          <a href="#contact"  className="btn btn-primary"   onClick={handleAnchorClick}>Get in Touch</a>
          <a href="#projects" className="btn btn-secondary" onClick={handleAnchorClick}>View Projects</a>
        </div>
      </div>

      <div className="hero-scroll-hint">
        <span className="font-mono">scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}

export default Hero;
